import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { ReportService } from '../services/report.service';

@Component({
    selector: 'app-score-item',
    templateUrl: './score-item.component.html',
    styleUrls: ['./score-item.component.css'],
    standalone: false
})
export class ScoreItemComponent implements OnInit {

  @Input() areaId: string;
  //areaDoc: AngularFirestoreDocument<Area>;
  listOfItems$: Observable<any[]>
  listOfItems: any[];

  constructor(
    private reportService: ReportService,
    private route: ActivatedRoute,
    //private db: AngularFirestore
  ) { }

  async ngOnInit() {
    await this.showItems();
  }

  async showItems() {
    let reportId = this.route.snapshot.params['repId'];
    let secId = this.route.snapshot.params['secId'];

    this.listOfItems = await this.reportService.readItemsByReportIdAsync(secId, reportId, this.areaId);

    //Versión anterior a Firestore Modular
    // this.areaDoc = this.db.doc<Area>('sections/' + secId + '/templates/' + reportId + '/areas/' + this.areaId);

    // this.listOfItems$ = this.areaDoc.collection<AreaItem>('items', ref => {
    //   return ref.orderBy("date", "asc")
    // })
    // .snapshotChanges()
    // .pipe(
    //   map(actions => {
    //     return actions.map(a => {
    //         const data = a.payload.doc.data() as AreaItem
    //         const id = a.payload.doc.id;
    //         return { id, data }
    //     })
    //   })
    // )


  }
}
